<template>
    <div class="card mt-0 pt-2 pt-md-0">
        <div class="card-header bg-info">
            <h3 class="my-0">Reporte Guía Remisión Transportista</h3>
        </div>
        <div class="card mb-0">
            <div class="card-body">
                <div class="row">
                    <!-- Filtros -->
                    <div class="col-12">
                        <div class="row mt-2">
                            <div class="col-md-4">
                                <label class="control-label">Remitente</label>

                                <el-select
                                    placeholder="Seleccione un remitente"
                                    v-model="form.sender_id"
                                    clearable
                                    filterable
                                    remote
                                    :remote-method="searchRemotePersons_"
                                    :loading="loading_search_"
                                >
                                    <el-option v-for="(client, index) in clients_"
                                        :key="index"
                                        :label="client.name"
                                        :value="client.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-4">
                                <label class="control-label">Destinatario</label>

                                <el-select
                                    placeholder="Seleccione un destinatario"
                                    v-model="form.receiver_id"
                                    clearable
                                    filterable
                                    remote
                                    :remote-method="searchRemotePersons"
                                    :loading="loading_search"
                                >
                                    <el-option v-for="(client, index) in clients"
                                        :key="index"
                                        :label="client.name"
                                        :value="client.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-4">
                                <label class="control-label">Serie</label>

                                <el-select
                                    placeholder="Seleccione una serie"
                                    v-model="form.serie"
                                    clearable
                                >
                                    <el-option v-for="(serie, index) in series"
                                        :key="index"
                                        :label="serie.number"
                                        :value="serie.number"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-4">
                                <label class="control-label">Número</label>
                                <el-input v-model="form.number" placeholder="Ingrese Número"></el-input>
                            </div>

                            <div class="col-md-4">
                                <label class="control-label">Fecha de envio</label>
                                <el-select v-model="form.period"
                                   @change="changePeriod">
                                    <el-option key="month"
                                            label="Por mes"
                                            value="month"></el-option>
                                    <el-option key="between_months"
                                            label="Entre meses"
                                            value="between_months"></el-option>
                                    <el-option key="date"
                                            label="Por fecha"
                                            value="date"></el-option>
                                    <el-option key="between_dates"
                                            label="Entre fechas"
                                            value="between_dates"></el-option>
                                </el-select>
                            </div>

                            <template v-if="form.period === 'month' || form.period === 'between_months'">
                                <div class="col-md-4">
                                    <label class="control-label">Mes de</label>
                                    <el-date-picker v-model="form.start_month"
                                        :clearable="false"
                                        format="MM/yyyy"
                                        type="month"
                                        value-format="yyyy-MM"
                                        @change="changeDisabledMonths"></el-date-picker>
                                </div>
                            </template>
                            <template v-if="form.period === 'between_months'">
                                <div class="col-md-4">
                                    <label class="control-label">Mes al</label>
                                    <el-date-picker v-model="form.end_month"
                                        :clearable="false"
                                        :picker-options="pickerOptionsMonths"
                                        format="MM/yyyy"
                                        type="month"
                                        value-format="yyyy-MM"></el-date-picker>
                                </div>
                            </template>
                            <template v-if="form.period === 'date' || form.period === 'between_dates'">
                                <div class="col-md-4">
                                    <label class="control-label">Fecha del</label>
                                    <el-date-picker v-model="form.start_date"
                                        :clearable="false"
                                        format="dd/MM/yyyy"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        @change="changeDisabledDates"></el-date-picker>
                                </div>
                            </template>
                            <template v-if="form.period === 'between_dates'">
                                <div class="col-md-4">
                                    <label class="control-label">Fecha al</label>
                                    <el-date-picker v-model="form.end_date"
                                        :clearable="false"
                                        :picker-options="pickerOptionsDates"
                                        format="dd/MM/yyyy"
                                        type="date"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </div>
                            </template>

                            <div class="col-12 mt-3">
                                <el-button type="primary"
                                    icon="el-icon-search"
                                    :loading="loading_submit"
                                    @click="getRecords"
                                >
                                    Buscar
                                </el-button>

                                <template v-if="records.length">
                                    <el-button type="success"
                                        @click="clickDownload"
                                    >
                                        <i class="fa fa-file-excel"></i> Exportar Excel
                                    </el-button>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- Tabla -->
                    <div class="col-12 mt-2">
                        <div class="table-responsive">
                            <table class="table"
                                v-loading="loading_submit"
                            >
                                <thead>
                                    <th>#</th>
                                    <th class="text-center">Fecha de Emisión</th>
                                    <th class="text-center">Número</th>
                                    <th>Remitente</th>
                                    <th>Punto de partida</th>
                                    <th>Destinatario</th>
                                    <th>Punto de llegada</th>
                                    <th>Estado</th>
                                    <th class="text-center">Fecha Envío</th>
                                    <th>Doc. relacionado</th>
                                    <th>N° de bultos</th>
                                </thead>
                                <tbody>
                                    <template v-if="records.length">
                                        <tr v-for="(record, index) in records"
                                        >
                                            <td>{{ customIndex(index) }}</td>
                                            <td class="text-center">{{ record.date_of_issue }}</td>
                                            <td class="text-center">{{ record.number }}</td>
                                            <td>{{ record.sender_name }}</td>
                                            <td>{{  record.starting_point }}</td>
                                            <td>{{ record.receiver_name }}</td>
                                            <td>{{ record.arrival_point }}</td>
                                            <td>
                                                <span class="badge bg-secondary text-white"
                                                :class="{'bg-secondary': (record.state_type_id === '01'), 'bg-info': (record.state_type_id === '03'), 'bg-success': (record.state_type_id === '05'), 'bg-secondary': (record.state_type_id === '07'), 'bg-dark': (record.state_type_id === '09')}">{{
                                                    record.state_type_description
                                                }}</span>
                                            </td>
                                            <td class="text-center">{{ record.date_of_shipping }}</td>
                                            <td class="text-center">
                                                <template v-if="record.qty_reference_documents > 0">
                                                    <el-button type="success"
                                                        icon="el-icon-document"
                                                        size="mini"
                                                        @click="showReferenceDocuments(record.reference_documents)"
                                                    ></el-button>
                                                </template>
                                            </td>
                                            <td>{{ record.number_of_packages }}</td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td colspan="7" class="text-center">Sin información disponible</td>
                                    </tr>
                                </tbody>
                            </table>
                            <el-pagination
                                :total="pagination.total"
                                :current-page.sync="pagination.current_page"
                                :page-size="pagination.per_page"
                                layout="total, prev, pager, next"
                                @current-change="getRecords"
                            ></el-pagination>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import queryString from 'query-string'
import { generateUuid } from '../../../../../../../resources/js/helpers/generateUuid';

export default {
    
    data() {
        return {
            resource_search: 'reports/guides',
            loading_submit: false,
            form: {},
            clients: [],
            clients_: [],
            series: [],
            pagination: {
                total: 0,
                current_page: 1,
                per_page: 0,
                last_page: 0
            },
            records: [],
            pickerOptionsDates: {
                disabledDate: (time) => {
                    time = moment(time).format('YYYY-MM-DD')
                    return this.form.date_start > time
                }
            },
            pickerOptionsMonths: {
                disabledDate: (time) => {
                    time = moment(time).format('YYYY-MM')
                    return this.form.start_month > time
                }
            },
            loading_search_: false,
            loading_search: false,
        }
    },

    async created() {
        this.initForm()
        await this.getDataFilters()
    },

    async mounted() {
        await this.getRecords()
    },

    methods: {
        initForm() {
            this.form = {
                sender_id: null,
                receiver_id: null,
                serie: null,
                number: null,
                period: 'month',
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                start_month: moment().format('YYYY-MM'),
                end_month: moment().format('YYYY-MM'),
            }
        },

        async getDataFilters() {
            const response = await this.$http.get(`/${this.resource_search}/data_table`)
            this.clients = response.data.persons
            this.clients_ = response.data.persons
            this.series = response.data.series
        },

        async getRecords() {
            this.loading_submit = true
            try {
                const response = await this.$http.get(`/${this.resource_search}/dispatch-carrier?${this.getQueryParameters()}`)
                console.log('getRecords')
                console.log(response.data.data)
                this.records = response.data.data
                this.pagination = response.data.meta
                this.pagination.per_page = parseInt(response.data.meta.per_page)
            } catch (error) {
                
            } finally {
                this.loading_submit = false
            }
        },

        getQueryParameters() {
            return queryString.stringify({
                page: this.pagination.current_page,
                limit: this.limit,
                ...this.form
            })
        },

        changeDisabledDates() {
            if (this.form.end_date < this.form.start_date) {
                this.form.end_date = this.form.start_date
            }
        },

        changeDisabledMonths() {
            if (this.form.end_month < this.form.start_month) {
                this.form.end_month = this.form.start_month
            }
        },

        changePeriod() {
            if (this.form.period === 'month') {
                this.form.start_month = moment().format('YYYY-MM')
                this.form.end_month = moment().format('YYYY-MM')
            }
            if (this.form.period === 'between_months') {
                this.form.start_month = moment().startOf('year').format('YYYY-MM')
                this.form.end_month = moment().endOf('year').format('YYYY-MM')
            }
            if (this.form.period === 'date') {
                this.form.start_date = moment().format('YYYY-MM-DD')
                this.form.end_date = moment().format('YYYY-MM-DD')
            }
            if (this.form.period === 'between_dates') {
                this.form.start_date = moment().subtract(1, 'days').format('YYYY-MM-DD')
                this.form.end_date = moment().format('YYYY-MM-DD')
            }
        },

        clickDownload() {
            const uuid = generateUuid()
            window.open(`/${this.resource_search}/excel_dispatch_carrier?${this.getQueryParameters()}&_v=${uuid}`, '_blank')
        },

        customIndex(index) {
            return (this.pagination.per_page * (this.pagination.current_page - 1)) + index + 1
        },

        searchRemotePersons_(input) {
            this.loading_search_ = true
            this.clients_ = []
            let identity_document_type_id = ['6', '4', '1', '0'];
            this.$http.post(`/${this.resource_search}/search_person`, {
                'identity_document_type_id': identity_document_type_id,
                'input': input
            })
                .then(response => {
                    this.clients_ = response.data.persons
                    this.loading_search_ = false
                })
        },

        searchRemotePersons(input) {
            this.loading_search = true
            this.clients = []
            let identity_document_type_id = ['6', '4', '1', '0'];
            this.$http.post(`/${this.resource_search}/search_person`, {
                'identity_document_type_id': identity_document_type_id,
                'input': input
            })
                .then(response => {
                    this.clients = response.data.persons
                    this.loading_search = false
                })
        },

        showReferenceDocuments(reference_documents) {
            this.$msgbox({
                title: 'Documentos relacionados',
                message: `
                    <div>
                        ${reference_documents.map(doc => `<span>${doc.document_type.description}: ${doc.number}</span><span class="ml-2">RUC: ${doc.ruc}</span>`).join('')}
                    </div>
                `,
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
                showConfirmButton: false,
            })
        }

    }
}
</script>


// WEBPACK FOOTER //
// modules/Report/Resources/assets/js/views/guide/report_dispatch_carrier.vue